<template>
  <div id="login" class="login f-c-s">
    <div class="loginpage f-c-s f-d-c w-66 h-100">
      <div class="f-c-c w-100 h-15">
        <Navbar />
      </div>
      <div
        class="f-c-sa justifyContent1400 pl-5 pr-5 w-100 h-70"
        style="margin-right: 40px"
      >
        <div class="loginBox f-c-s f-d-c">
          <div class="title w-100 f-c-c mt-5">تایید کد</div>
          <div class="inputLabel w-100 f-c-s mt-5 mb-2">کد تایید</div>
          <div class="inputSec f-c-s w-100 mb-5">
            <img class="ml-2" :src="require(`@/assets/images/login/key.svg`)" />
            <input
              type="text"
              autofocus
              id="verificationInput"
              v-model="code"
              @keyup.enter="enterMobileFunc()"
            />
          </div>
          <!-- <div class="change-repeat f-c-b mb-4">
            <div class="change f-c-c" @click.prevent="goToLogin()">
              تغییر شماره تلفن
            </div>
          </div> -->
          <div class="enterBtn f-c-c mb-4" @click.prevent="enterMobileFunc()">
            تایید
          </div>
        </div>
        <lottie :options="defaultOptions" id="loginJsonAnimation" />
      </div>

      <div
        class="gapMaterial pl-5 pr-5 f-c-b w-100 h-15"
      >
        <div class="text f-c-c">
          کلیه حقوق مادی و معنوی متعلق به دانشگاه آزاد اسلامی واحد الکترونیکی می
          باشد.
        </div>
        <a
          data-v-efcdee58=""
          style="width: 80px; height: 80px"
          referrerpolicy="origin"
          target="_blank"
          href="https://trustseal.enamad.ir/?id=326758&amp;Code=bjOij5apDKj7OdTL5Wi7"
          ><img
            data-v-efcdee58=""
            referrerpolicy="origin"
            src="https://vadaroom.ec.iau.ir/img/logo_enamad.png"
            alt=""
            id="bjOij5apDKj7OdTL5Wi7"
            style="cursor: pointer; width: 100%; height: 100%"
        /></a>
      </div>
    </div>
    <div class="area loginArea">
      <ul class="circles">
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/1.png`)"
          ></b-img>
        </li>
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/2.png`)"
          ></b-img>
        </li>
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/3.png`)"
          ></b-img>
        </li>
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/4.png`)"
          ></b-img>
        </li>
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/5.png`)"
          ></b-img>
        </li>
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/6.png`)"
          ></b-img>
        </li>
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/7.png`)"
          ></b-img>
        </li>
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/8.png`)"
          ></b-img>
        </li>
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/9.png`)"
          ></b-img>
        </li>
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/10.png`)"
          ></b-img>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Lottie from "vue-lottie";
import * as animationData from "@/assets/images/data.json";
import CopyRight from "@/components/CopyRight.vue";
import { EventBus } from "@/assistant/EventBus";
import Navbar from "@/components/LoginNavbar";
import Timer from "@/components/Timer";
import { mapState, mapActions } from "vuex";
export default {
  name: "Verification",
  data() {
    return {
      code: "",
      time: 60,
      timeStatus: true,
      isShowCopy: false,
      defaultOptions: { animationData: animationData },
    };
  },
  created() {
    this.isShowNavFunction(1);
    EventBus.$on("copyright", (status) => {
      if (status && this.isShowCopy) {
        this.isShowCopy = false;
      }
    });
  },
  computed: {
    prettyTime() {
      let hour = 0;
      let time = this.time / 60;
      let minutess = parseInt(time);
      let secondes = Math.round((time - minutess) * 60);
      return [hour, minutess, secondes];
    },
    ...mapState({
      user: (state) => state.gap.user,
      userStatus: (state) => state.gap.userStatus,
      verificationStatus: (state) => state.gap.verificationStatus,
      register: (state) => state.gap.register,
    }),
  },
  components: { Navbar, Timer, CopyRight, lottie: Lottie },
  methods: {
    ...mapActions("gap", ["confirmCodeFunction", "isShowNavFunction"]),
    copyRightFunc() {
      this.isShowCopy = !this.isShowCopy;
    },
    enterMobileFunc() {
      this.confirmCodeFunction({
        user_id:
          this.verificationStatus == 1
            ? this.register.user_id
            : this.user.user_id,
        code: this.code,
        session_url: "",
      });
    },
    resiveCodeAgainFunc() {
      this.time = 60;
      this.timeStatus = false;
      this.timeInterval();
    },
    goToLogin() {
      if (this.verificationStatus == 1) {
        this.$router.push({ name: "register" });
      } else if (this.verificationStatus == 2) {
        this.$router.push({ name: "forgotPassword" });
      } else {
        this.$router.push({ name: "login" });
      }
    },
    timeInterval() {
      this.timer = setInterval(() => {
        if (this.time > 0) {
          this.time--;
        } else {
          clearInterval(this.timer);
        }
      }, 1000);
    },
  },
  watch: {
    userStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100 || n.code == 107) {
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
          setTimeout(() => {
            if (this.verificationStatus == 3) {
              this.$router.push({ name: "myMeets" });
            } else {
              this.$router.push({ name: "loginWithPass" });
            }
          }, 1000);
        } else if (n.code == 203) {
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
          setTimeout(() => {
            this.$router.push({ name: "completionInformation" });
          }, 1000);
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    time(n) {
      if (n == 0) {
        this.timeStatus = true;
      }
    },
  },
  mounted() {
    setTimeout(() => {
      document.getElementById("verificationInput").focus();
    }, 500);
    // if (Object.keys(this.user).length && this.user.user_id) {
    //   this.$router.push({ name: "myUsers" });
    // }
  },
};
</script>
<style lang="scss" scoped>
.circles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.circles li {
  position: absolute;
  display: block;
  list-style: none;
  width: 20px;
  height: 20px;
  animation: animate 20s linear infinite;
  bottom: -30px;
}

.circles li:nth-child(1) {
  left: 3%;
  width: 50px;
  height: 50px;
  animation-delay: 0s;
}

.circles li:nth-child(2) {
  left: 5%;
  width: 50px;
  height: 50px;
  animation-delay: 0s;
  animation-duration: 12s;
  bottom: 150px;
}

.circles li:nth-child(3) {
  left: 7%;
  width: 50px;
  height: 50px;
  animation-delay: 0s;
}

.circles li:nth-child(4) {
  left: 90%;
  width: 60px;
  height: 60px;
  animation-delay: 0s;
  animation-duration: 18s;
  bottom: 100px;
}

.circles li:nth-child(5) {
  left: 7%;
  width: 50px;
  height: 50px;
  animation-delay: 0s;
}

.circles li:nth-child(6) {
  left: 95%;
  width: 50px;
  height: 50px;
  animation-delay: 0s;
  bottom: 200px;
}

.circles li:nth-child(7) {
  left: 95%;
  width: 50px;
  height: 50px;
  animation-delay: 0s;
}

.circles li:nth-child(8) {
  left: 90%;
  width: 50px;
  height: 50px;
  animation-delay: 0s;
  animation-duration: 45s;
  bottom: 170px;
}

.circles li:nth-child(9) {
  left: 93%;
  width: 50px;
  height: 50px;
  animation-delay: 0s;
  animation-duration: 35s;
  bottom: 50px;
}

.circles li:nth-child(10) {
  left: 2%;
  width: 50px;
  height: 50px;
  animation-delay: 0s;
  animation-duration: 11s;
}

@keyframes animate {
  0% {
    transform: translateY(0) rotate(0deg);
    opacity: 0.3;
  }

  100% {
    transform: translateY(-1000px) rotate(720deg);
    opacity: 0;
  }
}
</style>